export default "334ec0dd14b9f9ca.svg"